import Vue from 'vue'
import axios from 'axios'
import ViewUI from 'view-design'
import '../my-theme/index.less';
import App from './App'
import store from './store'
import router from './router'
import './global.js'
//import 'view-design/dist/styles/iview.css'
import './permission'
import Stomp from "stompjs";
import $ from 'jquery'

Vue.config.productionTip = false
Vue.use(ViewUI)

// 设置基础URL
axios.defaults.baseURL = ''
// 设置请求超时时间
// axios.defaults.timeout = 600000

Vue.prototype.$axios = axios

new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App),
})